import { UseFormSetValue } from 'react-hook-form';
import { TFormData } from '../../formSchema';
import { TUploadDocumentResponse } from '../../../../../utils/types';
import { useUploadDocumentMutation } from '../../../../../services/plants';
import { useAppDispatch } from '../../../../../storeHook';
import { showAlert } from '../../../../../services/alert';

export const useFileUpload = (
  setValue: UseFormSetValue<TFormData>
) => {
  const dispatch = useAppDispatch();
  const [uploadDocument] = useUploadDocumentMutation();
  const setDocumentUrl = (
    data: TUploadDocumentResponse,
    type: string
  ) => {
    switch (type) {
      case 'GST':
        setValue(
          'gstSchema.gstDetails.uploadedGstFile',
          data
        );
        break;
      case 'PAN':
        setValue(
          'panSchema.panDetails.uploadedPanFile',
          data
        );
        break;
      case 'CANCELLED_CHEQUE':
        setValue(
          'bankSchema.bankDetails.uploadedCancelChequeFile',
          data
        );
        break;
    }
  };

  const fileUpload = (
    file: File | undefined,
    type: string
  ) => {
    if (file) {
      if (file.size <= 10000000) {
        const data = new FormData();
        data.append('file', file);
        data.append('docType', type);
        uploadDocument({ data, type })
          .unwrap()
          .then((res) => {
            if (res) {
              setDocumentUrl(res, type);
            }
          });
      } else {
        dispatch(
          showAlert({
            content: 'Please attach image size upto 10 MB',
            severity: 'error',
          })
        );
      }
    }
  };

  return fileUpload;
};
